
export const CREATE_SPECIAL_OFFERS_SUCCESS = 'CREATE_SPECIAL_OFFERS_SUCCESS';
export const CREATE_SPECIAL_OFFERS_REQUEST = 'CREATE_SPECIAL_OFFERS_REQUEST';
export const CREATE_SPECIAL_OFFERS_FAILURE = 'CREATE_SPECIAL_OFFERS_FAILURE';

export const GET_SPECIAL_OFFERS_SUCCESS = 'GET_SPECIAL_OFFERS_SUCCESS';
export const GET_SPECIAL_OFFERS_REQUEST = 'GET_SPECIAL_OFFERS_REQUEST';
export const GET_SPECIAL_OFFERS_FAILURE = 'GET_SPECIAL_OFFERS_FAILURE';

export const GET_OFFERS_SUCCESS = 'GET_OFFERS_SUCCESS';
export const GET_OFFERS_REQUEST = 'GET_OFFERS_REQUEST';
export const GET_OFFERS_FAILURE = 'GET_OFFERS_FAILURE';

export const GET_OFFERS_BY_VENDOR_SUCCESS = 'GET_OFFERS_BY_VENDOR_SUCCESS';
export const GET_OFFERS_BY_VENDOR_REQUEST = 'GET_OFFERS_BY_VENDOR_REQUEST';
export const GET_OFFERS_BY_VENDOR_FAILURE = 'GET_OFFERS_BY_VENDOR_FAILURE';

export const GET_ALL_OFFERS_SUCCESS = 'GET_ALL_OFFERS_SUCCESS';
export const GET_ALL_OFFERS_REQUEST = 'GET_ALL_OFFERS_REQUEST';
export const GET_ALL_OFFERS_FAILURE = 'GET_ALL_OFFERS_FAILURE';

